import { trpc } from "lib/trpc";
import { DiscussionsList } from "@compass/shared/types";

export const useDiscussions = (input: DiscussionsList) => {
    const query = trpc.discussions.list.useQuery(input, {
        placeholderData: (prev) => prev,
    });

    const { data, isInitialLoading } = query;
    const nothingFound = Boolean(
        !isInitialLoading && data && data.totalFound === 0 && Object.keys(input).length,
    );

    return { ...query, nothingFound };
};
